import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useCommunicationChatEventsApi } from '@/features/api/hooks/communication-chat-events/useCommunicationChatEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useDeleteChatMessage = () => {
  const queryClient = useQueryClient();
  const api = useCommunicationChatEventsApi();

  return useApiMutation({
    mutationFn: (chatMessageId: string) =>
      api.onChatMessageDeleteRequest({
        clientChatMessageDeleteRequest: { chatMessageId }
      }),
    errorMessageKey: 'deleteChatMessage.error',
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.CHAT, data.chatMessage.chatId]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.CHAT_MESSAGES, data.chatMessage.chatId]
      });
    }
  });
};
